import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, Grid, Select, MenuItem, FormControl,
  InputLabel, Alert, Skeleton, Chip } from '@mui/material';
import { viewerAPI } from '../../services/api';
import { renderChart } from '../../components/Charts';

export default function ViewerDashboard() {
  var cx = useState(null); var context = cx[0]; var setContext = cx[1];
  var sel = useState(''); var selected = sel[0]; var setSelected = sel[1];
  var dd = useState(null); var dash = dd[0]; var setDash = dd[1];
  var ld = useState(true); var loading = ld[0]; var setLoading = ld[1];
  var er = useState(''); var error = er[0]; var setError = er[1];

  useEffect(function() {
    viewerAPI.context().then(function(r) {
      var c = r.data.data;
      setContext(c);
      if (c.dashboards && c.dashboards.length > 0) setSelected(c.dashboards[0].id);
      setLoading(false);
    }).catch(function() {
      setError('Could not load your access settings.');
      setLoading(false);
    });
  }, []);

  useEffect(function() {
    if (!selected) return;
    setDash(null);
    viewerAPI.dashboardData(selected)
      .then(function(r) { setDash(r.data.data); })
      .catch(function(e) {
        setError((e.response && e.response.data && e.response.data.error) || 'Could not load this dashboard.');
      });
  }, [selected]);

  var E = React.createElement;

  if (loading) {
    return E(Box, null,
      E(Skeleton, {variant:'text', width:240, height:44}),
      E(Skeleton, {variant:'rectangular', height:260, sx:{mt:2, borderRadius:2}}));
  }

  if (error && !dash) return E(Alert, {severity:'error'}, error);

  var dashboards = (context && context.dashboards) || [];
  if (dashboards.length === 0) {
    return E(Card, null, E(CardContent, {sx:{textAlign:'center', py:8}},
      E(Typography, {variant:'h6', sx:{mb:1}}, 'No dashboards yet'),
      E(Typography, {color:'text.secondary'},
        'An administrator needs to build a dashboard and grant you access to its form.')));
  }

  return E(Box, null,
    E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'center',
      flexWrap:'wrap', gap:2, mb:3}},
      E(Typography, {variant:'h4'}, dash ? dash.title : 'Dashboard'),
      dashboards.length > 1
        ? E(FormControl, {size:'small', sx:{minWidth:240}},
            E(InputLabel, null, 'Dashboard'),
            E(Select, {value:selected, label:'Dashboard',
              onChange:function(e){ setSelected(e.target.value); }},
              dashboards.map(function(d) {
                return E(MenuItem, {key:d.id, value:d.id}, d.title);
              })))
        : null),

    dash && dash.description
      ? E(Typography, {variant:'body2', color:'text.secondary', sx:{mb:2}}, dash.description) : null,

    dash
      ? E(Box, null,
          E(Chip, {label:dash.applications + ' applications', size:'small', sx:{mb:2}}),
          E(Grid, {container:true, spacing:2},
            (dash.charts || []).map(function(c) {
              var wide = c.type === 'table' || c.type === 'line' || c.type === 'column';
              return E(Grid, {item:true, xs:12, md: wide ? 12 : 6, key:c.id},
                E(Card, {sx:{height:'100%'}},
                  E(CardContent, null,
                    E(Box, {sx:{display:'flex', justifyContent:'space-between',
                      alignItems:'baseline', gap:1, mb:1.5}},
                      E(Typography, {variant:'subtitle1', fontWeight:600}, c.title || 'Untitled'),
                      E(Typography, {variant:'caption', color:'text.secondary'},
                        c.answered + ' answered')),
                    c.error
                      ? E(Alert, {severity:'warning'}, c.error)
                      : renderChart(c),
                    c.truncated
                      ? E(Typography, {variant:'caption', color:'text.secondary',
                          sx:{display:'block', mt:1, fontStyle:'italic'}},
                          'Showing the most common answers only')
                      : null)));
            })),
          (dash.charts || []).length === 0
            ? E(Alert, {severity:'info', sx:{mt:2}}, 'This dashboard has no charts configured yet.')
            : null)
      : E(Skeleton, {variant:'rectangular', height:300, sx:{borderRadius:2}}));
}
